module.exports = __webpack_public_path__ + "img/114.6e4b1c35.jpg";